"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _classnames = _interopRequireDefault(require("classnames"));

var s = _interopRequireWildcard(require("./UserImage.style"));

var UserImage = function UserImage(_ref) {
  var name = _ref.name,
      url = _ref.url,
      className = _ref.className,
      theme = _ref.theme;

  if (!url) {
    var initials = name.match(/\b\w/g) || [];
    initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
    return _react.default.createElement("div", {
      className: (0, _classnames.default)(s.noImage(theme), className)
    }, initials);
  }

  return _react.default.createElement("div", {
    className: s.imageContainer
  }, _react.default.createElement("img", {
    alt: name,
    src: url,
    className: (0, _classnames.default)(s.userImage, className)
  }));
};

UserImage.defaultProps = {
  className: ''
};
UserImage.prototypes = {
  name: _propTypes.default.string.isRequired,
  url: _propTypes.default.string,
  className: _propTypes.default.string
};

var _default = (0, _emotionTheming.withTheme)(UserImage);

exports.default = _default;